import {twMerge} from '@sdox/utils'

import type {PropsWithChildren} from 'react'

interface CounterProps extends PropsWithChildren {
  className?: string
}

export const Counter = ({children, className}: CounterProps) => (
  <div
    className={twMerge(
      'absolute left-0 top-0 z-20 size-full backdrop-blur-1',
      // FIXME MR:1707
      // bg-interactive-surface-primary-default-default/80
      // group-hover:bg-interactive-surface-primary-default-hovered/90
      'bg-scrim-primary/80 group-hover:bg-scrim-primary/90',
      'flex-1 items-center justify-center gap-spacing-4',
      'text-p1 text-white @block-large:text-h3',
      className,
    )}
  >
    <span>+</span><span>{children}</span>
  </div>
)
